import React, { useState, useRef, useEffect, useContext } from 'react';
import './hidescrollbarx.css';
import { LatestSessions } from '../../Services/allApi';
import { addcontext } from '../../ContextShare/ContextShare';
import { useNavigate } from 'react-router-dom';
import dummyThumbnail from '../../Assets/Screenshot from 2024-06-03 14-07-54.png';
import language from '../../language.json';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './LatestSession.css'; // Import the CSS for overlay

function LatestSession() {
    const baseUrl = process.env.REACT_APP_BASEURL;
    const altimg = process.env.REACT_APP_ALT_IMG;
    const { videoData, setVideoData } = useContext(addcontext);
    const [currentLanguage, setCurrentLanguage] = useState();
    const { langChanged, setlangChanged } = useContext(addcontext);
    const { videoUrl, setVideoUrl } = useContext(addcontext);
    const { videoThumb, setVideoThumb } = useContext(addcontext);
    const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext);
    const [sessions, setSessions] = useState([]);
    const scrollContainerRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState();
    // handle scroll left
    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -500,
                behavior: 'smooth',
            });
        }
    };
    // handle scroll right
    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 500,
                behavior: 'smooth',
            });
        }
    };
    // latest session fetch api
    const getLatestSession = async () => {
        try {
            const result = await LatestSessions();
            console.log(result);
            setTimeout(() => {
                setSessions(result?.data);
            }, 500);
            setErrorMessage(result?.response?.data?.message);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getLatestSession();
    }, []);

    const navigate = useNavigate();
    // redirect to video play page
    const handleVideoUrl = (e) => {
        setVideoUrl(e.video_url);
        setVideoThumb(e.video_thumbnail);
        setVideoData(e);
        if (e?.mapping_id) {
            console.log(e?.mapping_id);
            navigate(`/video/:${e?.mapping_id}`);
        }
    };

    useEffect(() => {
        setCurrentLanguage(localStorage.getItem('language') || 'en');
    }, [currentLanguage, langChanged]);

    return (
        <>
            <div className='flex flex-row'>
                <div className='w-1/12 flex justify-center items-center'>
                    <i className="fa-solid fa-chevron-left fa-xl" onClick={scrollLeft} style={{ cursor: 'pointer' }} title='Scroll Left'></i>
                </div>

                <div className="flex flex-col m-auto p-auto w-10/12" style={{ fontFamily: "Ropa Sans" }}>
                    <h1 className="flex py-5 font-bold text-4xl lg:justify-start justify-center" style={{ color: '#001F33' }}>
                        {language.latest_session[currentLanguage]}
                    </h1>

                    {sessions?.length > 0 ? (
                        <div className="flex overflow-x-scroll pb-10 hide-scroll-bar" ref={scrollContainerRef}>
                            <div className="flex flex-nowrap mt-10">
                                {sessions?.length > 0 ? sessions?.map(sessionvalues => (
                                    <div className="inline-block me-20" key={sessionvalues.id}>
                                        <div onClick={() => handleVideoUrl(sessionvalues)} style={{ width: '460px' }} className="h-80 overflow-hidden hover:shadow-xl transition-shadow duration-300 ease-in-out rounded relative">
                                            <img
                                                src={sessionvalues?.video_thumbnail ? `${baseUrl}${sessionvalues.video_thumbnail}` : altimg}
                                                style={{ width: '100%', height: '90%' }}
                                                alt='Thumbnail'
                                            />
                                            <div className='txts flex flex-row justify-between '>
                                                <h2 className='ms-2 mt-1' style={{ color: '#001F33' }}>
                                                    {currentLanguage == 'en' ? sessionvalues?.video_event?.slice(0, 24) : sessionvalues?.malayalam_video_event?.slice(0, 24)}
                                                </h2>
                                                <h5 className='me-2 text-xs items-center mt-2 text-slate-500 hover:hidden'>{sessionvalues?.video_upload_date}</h5>
                                            </div>
                                            <div className="overlay flex flex-col">
                                                <div className="overlay-text">
                                                    {currentLanguage == 'en' ? sessionvalues?.video_event : sessionvalues?.malayalam_video_event}
                                                </div>
                                                <div className="overlay-text">
                                                {sessionvalues?.video_upload_date}
                                                </div>

                                                <div className='flex flex-row justify-center gap-5 w-full mt-1'>
                                                    
                                                <div className='text-white text-sm'>
                                                {language.kla[currentLanguage]} : {sessionvalues?.kla}
                                                </div>

                                                <div className='text-white text-sm'>
                                                {language.Session[currentLanguage]} {}: {sessionvalues?.video_session}
                                                </div>
                                                
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )) : (
                                    <div className="flex flex-col justify-center items-center">
                                        <p className="text-red-800 text-lg font-semibold mt-4 text-center">{errorMessage}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className='flex flex-row md:justify-between justify-center pb-10 pt-5 overflow-hidden'>
                            <div className='md:flex hidden flex-col'>
                                <Skeleton height={285} width={600} />
                                <div className='flex flex-row justify-between'>
                                    <Skeleton height={10} width={400} />
                                    <Skeleton height={10} width={190} />
                                </div>
                            </div>

                            <div className='md:flex hidden flex-col'>
                                <Skeleton height={285} width={600} />
                                <div className='flex flex-row justify-between'>
                                    <Skeleton height={10} width={400} />
                                    <Skeleton height={10} width={190} />
                                </div>
                            </div>

                            <div className='md:hidden flex flex-col'>
                                <Skeleton height={285} width={350} />
                                <div className='flex flex-row justify-between'>
                                    <Skeleton height={10} width={230} />
                                    <Skeleton height={10} width={110} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className='w-1/12 flex justify-center items-center'>
                    <i className="fa-solid fa-chevron-right fa-xl" title='Scroll Right' onClick={scrollRight} style={{ cursor: 'pointer' }}></i>
                </div>
            </div>
        </>
    );
}

export default LatestSession;
